import Modal from "../../Modal";
import {
  Title,
  SubTitle,
  FlowName,
  Footer,
  Container,
  DivIcon,
} from "./styles";
import Button from "../../Button";
import Close from "../../../../assets/icons/Close";


import { usePromiseTracker } from 'react-promise-tracker';
import ReactLoading from 'react-loading';

const ExcludeFlowModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
  flowName,
}) => {
  const { promiseInProgress } = usePromiseTracker({ area: 'remove-flow' });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Excluir fluxo</Title>
        <SubTitle>Deseja seguir com a exclusão do fluxo?</SubTitle>
        {!promiseInProgress ? (
          <>
            <FlowName>{flowName}</FlowName>
            <Footer>
              <Button
                outline
                content="Cancelar"
                width={"11.3125rem"}
                height={"2.625rem"}
                onClick={onClose}
              />
              <Button
                content="Sim, excluir"
                width={"11.3125rem"}
                height={"2.625rem"}
                onClick={onConfirm}
              />
            </Footer>

          </>) : (

          <div
            style={{
              margin: '0 auto',
              padding: '2rem',

            }}
          >
            <ReactLoading type="bars" color="#118052" />
          </div>


        )}

        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default ExcludeFlowModal;
